<template>
    <div class="rounded w-full px-2">
        <div class="white-overlay" v-show="isContactsLoading">
            <div class="loading-loader" >
                <span class="fa fa-spinner fa-spin"></span> Loading
            </div>
        </div>
        <table class="text-left w-full border-collapse table-responsive" id="saleBehaviorContacts">
            <thead>
            <tr>
                <th :colspan="newColumns.length" class="text-center bg-teal text-white">
                    {{ salesBehaviorsContacts.name }}
                </th>
                <td class="text-right bg-teal text-white col-md-2">
                    <div class="col-sm-3 float-right">
                        <dashboard-export-icon-contact
                            :name="salesBehaviorsContacts.name"
                            :projects="salesBehaviorsContacts.data.contact"
                            :state="columns"
                            :masks="masks"
                            :filter="filter"
                            :user="user"
                            :user-ids="userIds"
                            :office-ids="officeIds"
                            :contract-type-ids="contractTypeIds"
                            :fixed-date-range-identifier="fixedDateRangeIdentifier"
                            :field-labels="fieldLabels"
                            @contactStateUpdated="stateUpdated"
                        />
                    </div>
                    <div class="col-sm-3 float-right">
                        <i class="fa fa-fw text-left fa-btn fa-external-link pointer" title="Export" @click="exportToExcel()"></i>
                    </div>
                </td>
            </tr>
            <tr>
                <th class="bg-grey-lightest border-b border-grey-light"></th>
                <th v-for="column in newColumns" class="pl-2 py-3 bg-grey-lightest text-center border-b border-grey-light">
                    <button class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline"
                            :class="currentOrder.sortBy === column.property_name ? 'text-teal' : ''"
                            @click="order(column.property_name)">
                        {{ column.name }}
                        <i class="fa fa-xs fa-chevron-down ml-2"
                           v-if="currentOrder.property === column.property_name && currentOrder.direction === 'desc'"></i>
                        <i class="fa fa-xs fa-chevron-up ml-2"
                           v-if="currentOrder.property === column.property_name && currentOrder.direction === 'asc'"></i>
                    </button>
                </th>
            </tr>
            </thead>
            <tbody class="sales-behaviors-list" id="infinite-list">
            <tr v-for="contact in salesBehaviorsContacts.data.contacts"
                class="hover:bg-grey-lighter cursor-pointer"
                @click="goToContact(contact)">
                <td v-if="newColumns.length > 0" :class="Number(contact.age) < 0 ? 'bg-green' : 'bg-red'" class="pl-2 py-2 border-b"></td>
                <td v-for="column in newColumns" class="pl-2 py-2 border-b border-grey-light text-center text-grey-darkest text-xs" :class="(
                        column.property_name == 'name' || column.property_name == 'email'
                        || column.property_name == 'cell' || column.property_name == 'title' || column.property_name == 'company_name'
                    ) ? 'text-break' : ''">
                    {{ (column.property_name == 'age') ? ( contact[column.property_name] < 0 ? '-' :  contact[column.property_name]): contact[column.property_name] }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ['salesBehaviorsContacts', 'currentOrder', 'state', 'masks', 'filter', 'user', 'fixedDateRangeIdentifier', 'contactCustomFields',
        'availableColumns', 'userIds', 'officeIds', 'contractTypeIds','fieldLabels', 'contactCustomFieldTypeConstants', 'isContactsLoading', 'contactNextPage'],

    data() {
        const stateCustomFields = this.contactCustomFields.map(customField => ({
            name: customField.label_value,
            checked: true,
            property_name: customField.name,
            is_custom_field: true,
            custom_field_id: customField.id,
            custom_field_type: this.contactCustomFieldTypeConstants[customField.type],
        }));
        const newState = {
            ...this.state,
            [this.salesBehaviorsContacts.name]: [
                {
                    name: 'Contact ID',
                    order: 'id',
                    customClass: '',
                    checked: true,
                    property_name: 'id',
                },
                {
                    name: 'Contact Name',
                    order: 'name',
                    customClass: 'w-1/5',
                    checked: true,
                    property_name: 'name',
                },
                {
                    name: 'Contact Type',
                    order: 'contact_type_name',
                    customClass: '',
                    checked: true,
                    property_name: 'contact_type_name',
                },
                {
                    name: 'Phone',
                    order: 'cell',
                    customClass: '',
                    checked: true,
                    property_name: 'cell',
                },
                {
                    name: 'Email',
                    order: 'email',
                    customClass: '',
                    checked: true,
                    property_name: 'email',
                },
                {
                    name: 'Title',
                    order: 'title',
                    customClass: '',
                    checked: true,
                    property_name: 'title',
                },
                {
                    name: 'Company Name',
                    order: 'company_name',
                    customClass: '',
                    checked: true,
                    property_name: 'company_name',
                },
                {
                    name: 'Due Date',
                    order: 'meeting_date',
                    customClass: '',
                    checked: true,
                    property_name: 'meeting_date',
                },
                {
                    name: 'Age',
                    order: 'age',
                    customClass: 'hidden lg:table-cell',
                    checked: true,
                    property_name: 'age',
                },
                ...stateCustomFields,
            ]
        };

        if (this.state && this.state[this.salesBehaviorsContacts.name]) {

            const stateHash = this.state[this.salesBehaviorsContacts.name].reduce(function (map, obj) {
                map[obj.name] = obj;
                return map;
            }, {});
            newState[this.salesBehaviorsContacts.name] = Object.values(stateHash);

        }else{
            const baseStateHash = newState[this.salesBehaviorsContacts.name].reduce(function (map, obj) {
                map[obj.name] = obj;
                return map;
            }, {});
            newState[this.salesBehaviorsContacts.name] = Object.values(baseStateHash);
        }
        const stateList =  newState[this.salesBehaviorsContacts.name].slice(0,11);

        return {
            columns: this.state? this.state : newState,
            newColumns : (this.availableColumns !== undefined) ? this.availableColumns: stateList,
            busy: false
        };
    },
    watch: {
        'availableColumns': function (value, oldValue) {
            if(value) {
                this.newColumns = value;
            }else{
                this.newColumns = this.columns[this.salesBehaviorsContacts.name].slice(0,11);
            }
        },
        'isContactsLoading': function (value, oldValue) {
            this.busy = value;
        }
    },
    mounted () {
        const listElm = document.querySelector('#saleBehaviorContacts');
        listElm.addEventListener('scroll', e => {
            if (listElm.scrollTop + listElm.clientHeight +10 >= listElm.scrollHeight) {
                this.loadMoreContacts();
            }
        });
    },
    methods: {
        goToContact(contact) {

            window.location = route('contact.edit', {company: contact.company_id, contact: contact.id});
        },
        exportToExcel() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            if(this.availableColumns.length > 0) {
                let newwindow = window.open(route('dashboard.excel.contact', {
                    "start-date": this.filter.start,
                    "end-date": this.filter.end,
                    "user": (this.userIds && this.userIds.length > 0) ?JSON.stringify(this.userIds) : JSON.stringify([]),
                    "office": (this.officeIds && this.officeIds.length > 0) ? JSON.stringify(this.officeIds) : null,
                    "contract-type": (this.contractTypeIds && this.contractTypeIds.length > 0) ? JSON.stringify(this.contractTypeIds) : null,
                    "behavior-name": this.salesBehaviorsContacts.name,
                    "columns": this.columns[this.salesBehaviorsContacts.name].filter((column) => {
                        if(column.checked) {
                            return column
                        }
                    }).map(column => ({
                        name: column.name,
                        property_name: column.property_name
                    })),
                }), this.salesBehaviorsContacts.name, 'location=0,width=860,height=740,toolbar=0,menubar=0,location=0');
                if (window.focus) {newwindow.focus()}
            }else{
                Toast.fire({
                    type: "error",
                    title: 'Select some columns to export'
                });
            }
        },
        order(property) {
            this.$emit('contactOrder', property);
        },
        stateUpdated(updatedState) {
            this.$emit('updateContactParentState', updatedState);
        },
        loadMoreContacts(){
            this.$nextTick(() => {
                if(this.contactNextPage && !this.isContactsLoading) {
                    this.busy = true;
                    this.$emit('fetchNextContacts', {page: this.contactNextPage});
                }
            });
        }
    }
}
</script>

<style>
.bg-qualified{
    background-color: #00ff8f;
}
.loading-loader {
    text-align: center;
    position: absolute;
    color: #fff;
    z-index: 9;
    background: #01b1af;
    padding: 8px 18px;
    border-radius: 5px;
    left: calc(50% - 45px);
    top: calc(50% - 18px);
}
.white-overlay {
    background-color: hsla(0,0%,100%,.75);
    z-index: 9999;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    position: fixed;
    margin: 0;
}
#saleBehaviorContacts {
    overflow: scroll;
    height: 800px;
}
</style>
